module.exports = __webpack_public_path__ + "static/img/5.c6cddf6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/eng/5.png
// module id = simP
// module chunks = 0